/** Rubrique Fournisseurs : CRUD (nom, type, contact, email, délai, conditions). */
import { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Plus, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { parametresApi } from '../../../services/api';
import { Button, Spinner, Card } from '../../../components/ui/kit';

export default function Fournisseurs({ readOnly }) {
  const qc = useQueryClient();
  const [form, setForm] = useState(null);
  const { data: suppliers, isLoading } = useQuery({ queryKey: ['suppliers'], queryFn: parametresApi.suppliers });
  const save = useMutation({ mutationFn: (p) => parametresApi.saveSupplier(p), onSuccess: () => { toast.success('Fournisseur enregistré'); setForm(null); qc.invalidateQueries({ queryKey: ['suppliers'] }); } });
  const del = useMutation({ mutationFn: (id) => parametresApi.deleteSupplier(id), onSuccess: () => qc.invalidateQueries({ queryKey: ['suppliers'] }) });
  if (isLoading) return <Spinner />;

  return (
    <div className="max-w-[760px]">
      <div className="flex items-center justify-between mb-5">
        <h2 className="font-title text-3xl">Fournisseurs</h2>
        {!readOnly && <Button variant="primary" disabled={!!form || save.isPending} onClick={() => setForm({ name: '', type: '', email: '', delay_days: '', conditions: '' })} data-testid="add-supplier"><Plus className="w-4 h-4" /> Ajouter</Button>}
      </div>
      {form && (
        <Card className="p-4 mb-4" data-testid="supplier-form">
          <div className="grid sm:grid-cols-2 gap-2">
            <input className="vd-input h-9" placeholder="Nom" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="supplier-name" />
            <input className="vd-input h-9" placeholder="Type (domaine, cave, importateur…)" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} />
            <input className="vd-input h-9" placeholder="Email de commande" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            <input className="vd-input h-9" placeholder="Délai (jours)" value={form.delay_days} onChange={(e) => setForm({ ...form, delay_days: e.target.value })} />
          </div>
          <textarea className="vd-input w-full mt-2 min-h-[52px]" placeholder="Conditions" value={form.conditions} onChange={(e) => setForm({ ...form, conditions: e.target.value })} />
          <div className="flex gap-2 mt-2"><Button variant="primary" onClick={() => save.mutate(form)} disabled={!form.name} data-testid="supplier-save">Enregistrer</Button><Button variant="ghost" onClick={() => setForm(null)}>Annuler</Button></div>
        </Card>
      )}
      <div className="vd-card overflow-hidden">
        <table className="w-full text-[13.5px]" data-testid="suppliers-table">
          <thead><tr className="text-left kicker"><th className="py-2.5 px-3">Nom</th><th className="py-2.5 px-3">Type</th><th className="py-2.5 px-3">Email</th><th className="py-2.5 px-3">Délai</th><th /></tr></thead>
          <tbody>
            {suppliers.length === 0 && <tr><td colSpan={5} className="py-6 text-center text-n600">Aucun fournisseur.</td></tr>}
            {suppliers.map((s) => (
              <tr key={s.id} className="hair-t" data-testid={`supplier-${s.id}`}>
                <td className="py-2.5 px-3">{s.name}</td><td className="py-2.5 px-3 text-n600">{s.type}</td>
                <td className="py-2.5 px-3 text-n600">{s.email}</td><td className="py-2.5 px-3 nums">{s.delay_days ? `${s.delay_days} j` : '—'}</td>
                <td className="py-2.5 px-3 text-right">{!readOnly && <button onClick={() => del.mutate(s.id)} className="text-n500 hover:text-red-600"><Trash2 className="w-4 h-4" /></button>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
